/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod';
import { AreaOfStudyCategory } from "../enums";
export const areaOfStudySchema = z.object({
  category: z.nativeEnum(AreaOfStudyCategory).nullish(),
  createdAt: z.string().datetime().nullish(),
  id: z.string().uuid(),
  name: z.string(),
  updatedAt: z.string().datetime().nullish(),
});

export type AreaOfStudy = z.infer<typeof areaOfStudySchema>;
